import { isTauri } from '@/tauri/utils';
import { getClientVersion } from '@/utils/appVersion';

export const X_CLIENT_ID = isTauri() ? 'desktop' : 'web';

/** Headers identifying the client platform and app version (APP-8775). */
export const getXClientHeaders = (): Record<string, string> => {
  const headers: Record<string, string> = { 'X-Client-Id': X_CLIENT_ID };
  const clientVersion = getClientVersion();
  if (clientVersion) {
    headers['X-Client-Version'] = clientVersion;
  }
  return headers;
};

export const applyXClientHeaders = (headers: { [key: string]: unknown }): void => {
  headers['X-Client-Id'] = X_CLIENT_ID;
  const clientVersion = getClientVersion();
  if (clientVersion) {
    headers['X-Client-Version'] = clientVersion;
  }
};
